import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import { DataGrid } from "@mui/x-data-grid";
import { NumericFormat } from "react-number-format";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { getAllExpense } from "../redux/handlers/logic/getAllExpense.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getSupplierFullName } from "utils/HelperFunction";
import moment from "moment";
export function ModalAdditionalCosts(_param) {
    var handleSubmit = _param.handleSubmit, modal = _param.modal, setModal = _param.setModal, setAdditionalCost = _param.setAdditionalCost, props = _object_without_properties(_param, [
        "handleSubmit",
        "modal",
        "setModal",
        "setAdditionalCost"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState([
        {
            id: 1,
            docNumber: "EXP-2024100001",
            supplierName: "บริษัท เอนเทอร์ อีเอสซี จำกัด",
            docDate: "05/04/2024",
            price_before_tax: 20400.0,
            net_price: 20400.0
        },
        {
            id: 2,
            docNumber: "EXP-2024100002",
            supplierName: "บริษัท เอนเทอร์ อีเอสซี จำกัด",
            docDate: "05/04/2024",
            price_before_tax: 20400.0,
            net_price: 20400.0
        }
    ]), 2), doc = _useState[0], setDoc = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), data = _useState1[0], setData = _useState1[1];
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState2 = _sliced_to_array(useState([]), 2), additionalCostSelected = _useState2[0], setAdditionalCostSelected = _useState2[1];
    var getAllExpenseReducer = useAppSelector(function(state) {
        return state.getAllExpenseReducer;
    });
    var getData = function() {
        var queryParams = {
            isNotReferOnly: "true"
        };
        dispatch(getAllExpense({
            modalObj: modalObj,
            setModalObj: setModalObj,
            queryParams: queryParams
        }));
    };
    useEffect(function() {
        if (modal.open) {
            getData();
        }
    }, [
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(getAllExpenseReducer.isFetching);
        if (getAllExpenseReducer.data && !getAllExpenseReducer.isError) {
            var result = getAllExpenseReducer.data.data;
            setData(result);
        }
    }, [
        getAllExpenseReducer
    ]);
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่เอกสาร",
            width: 160,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "#565DFF"
                        },
                        children: row.doc_number
                    })
                });
            }
        },
        {
            field: "supplier_name",
            headerName: "ผู้จัดจำหน่าย",
            width: 250,
            flex: 1,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออกเอกสาร",
            width: 200,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "total_price_before_vat",
            headerName: "มูลค่าก่อนภาษี",
            width: 150,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3 text-[#FF0000]",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 4,
                        fixedDecimalScale: true,
                        value: row.total_price_before_vat
                    })
                });
            }
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            width: 110,
            cellClassName: "d-flex justify-content-end",
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 4,
                        fixedDecimalScale: true,
                        value: row.grand_total_price
                    })
                });
            }
        }
    ];
    var _useState3 = _sliced_to_array(useState(""), 2), filterText = _useState3[0], setFilterText = _useState3[1];
    var filteredItems = data.filter(function(item) {
        var docNumberMatches = item.doc_number && item.doc_number.toLowerCase().includes(filterText.toLowerCase());
        var supplierNameMatches = item.dimSupplierInformation && getSupplierFullName(item.dimSupplierInformation).toLowerCase().includes(filterText.toLowerCase());
        return docNumberMatches || supplierNameMatches;
    });
    return /*#__PURE__*/ _jsxs(ModalAllder, {
        modal: modal,
        setModal: setModal,
        htitle: "โหลดเอกสาร",
        hbtn: true,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-end",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-[#FF731D] bg-[#F4F4F4] drop-shadow rounded ml-auto px-3 mr-3 py-2",
                        children: [
                            "เลือกไว้ ",
                            additionalCostSelected.length,
                            " รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "btn bg-[#FF6B00] text-white  disabled:bg-[#FF6B00]/[0.5] px-4",
                        disabled: !additionalCostSelected.length > 0,
                        onClick: function() {
                            setAdditionalCost(function(prev) {
                                return data.filter(function(row) {
                                    return additionalCostSelected.some(function(id) {
                                        return id === row.id;
                                    });
                                });
                            });
                            setAdditionalCostSelected([]);
                            setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        children: "ยืนยัน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center mb-4 mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "me-3",
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control form-st-4",
                            placeholder: "เลขที่เอกสาร",
                            onKeyUp: function(e) {
                                return setFilterText(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "btn bg-[#FF6B00] text-white  px-4",
                        children: "ค้นหา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DataGrid, {
                getRowId: function(row) {
                    return row.id;
                },
                getRowHeight: function() {
                    return "auto";
                },
                rows: filteredItems,
                autoHeight: true,
                columns: columnsd,
                initialState: {
                    pagination: {
                        paginationModel: {
                            pageSize: 10
                        }
                    }
                },
                pageSizeOptions: [
                    10,
                    20,
                    30
                ],
                checkboxSelection: true,
                disableRowSelectionOnClick: true,
                slotProps: {
                    pagination: {
                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                    }
                },
                disableMultipleRowSelection: false,
                rowSelectionModel: additionalCostSelected,
                sx: {
                    fontFamily: "Sarabun",
                    fontSize: "16px",
                    ".MuiDataGrid-columnHeaderTitle": {
                        fontFamily: "Sarabun",
                        fontSize: "16px"
                    },
                    "& .MuiDataGrid-virtualScrollerRenderZone": {
                        transform: "unset !important"
                    }
                },
                onRowSelectionModelChange: function(ids) {
                    setAdditionalCostSelected(ids);
                }
            })
        ]
    });
}
